module.exports = __webpack_public_path__ + "img/maisondesrefugies.826f1425.png";